export const isExtraCharged = (serviceTxn) => {
  const { serviceInfo, reservation } = serviceTxn
  return (
    (serviceInfo.guestPaxAdult || 0) > (reservation.guestPaxAdult || 0) ||
    (serviceInfo.guestPaxChild || 0) > (reservation.guestPaxChild || 0) ||
    (serviceInfo.guestPaxInfant || 0) > (reservation.guestPaxInfant || 0) ||
    (serviceInfo.luggageAmount || 0) > (reservation.luggageAmount || 0)
  )
}
